module.exports = __webpack_public_path__ + "static/media/03.e0caeb15.jpg";